import styled from 'styled-components';

export type StepProps = {
  goToNextStep: () => void;
  goToPreviousStep: () => void;
  currentStepIndex: number;
};

type StyledFlexStatusBoxContainerProps = {
  horizontalGapDesktop: number;
  verticalGapDesktop: number;
  horizontalGapMobile: number;
  verticalGapMobile: number;
};
export const StyledFlexStatusBoxContainer = styled.div<StyledFlexStatusBoxContainerProps>`
  display: flex;
  gap: ${({ horizontalGapDesktop }) => horizontalGapDesktop}px;
  margin-top: ${({ verticalGapDesktop }) => verticalGapDesktop}px;

  @media (max-width: 960px) {
    margin-top: ${({ verticalGapMobile }) => verticalGapMobile}px;
    gap: ${({ horizontalGapMobile }) => horizontalGapMobile}px;
  }
`;

type StyledArrowCenterBoxProps = StyledFlexStatusBoxContainerProps & {
  arrowRadius: number;
};
export const StyledArrowCenterBox = styled.div<StyledArrowCenterBoxProps>`
  position: absolute;

  width: calc(
    100% + ${({ horizontalGapDesktop }) => horizontalGapDesktop + 1}px
  );
  height: ${({ verticalGapDesktop }) => verticalGapDesktop / 2}px;
  top: -${({ verticalGapDesktop }) => verticalGapDesktop / 2}px;
  left: calc(50% - 0.5px);
  border: 1px dashed ${({ theme }) => theme.palette.stroke[1]};
  border-bottom: 0;
  border-top-left-radius: ${({ arrowRadius }) => arrowRadius}px;
  border-top-right-radius: ${({ arrowRadius }) => arrowRadius}px;
  border-bottom-left-radius: 0;
  border-bottom-right-radius: 0;

  @media (max-width: 960px) {
    width: calc(
      100% + ${({ horizontalGapMobile }) => horizontalGapMobile + 1}px
    );
    height: ${({ verticalGapMobile }) => verticalGapMobile / 2}px;
    top: -${({ verticalGapMobile }) => verticalGapMobile / 2}px;
  }

  div.chevron-container {
    position: absolute;
    left: -4px;
    top: calc(100% - 4px);
    width: 7px;
    height: 4px;
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 1;
    background-color: white;
    svg {
      width: 100%;
      height: 100%;
    }
  }
  div.right-chevron-container {
    left: calc(100% - 3px);
  }
`;

type StyledDotCenterProps = {
  dotSize: number;
  dotPadding: number;
};
export const StyledDotCenter = styled.div<StyledDotCenterProps>`
  width: ${({ dotSize }) => dotSize}px;
  height: ${({ dotSize, dotPadding }) => dotSize + dotPadding}px;
  background-color: white;
  position: absolute;
  top: calc(100% - ${({ dotSize }) => dotSize / 2}px);
  left: calc(50% - ${({ dotSize }) => dotSize / 2}px);
  z-index: 3;

  div.actual-dot {
    width: ${({ dotSize }) => dotSize}px;
    height: ${({ dotSize }) => dotSize}px;
    background-color: ${({ theme }) => theme.palette.stroke[1]};
    border-radius: 50%;
  }
`;

type StyledArrowTopProps = {
  arrowRadius: number;
  verticalGapDesktop: number;
  verticalGapMobile: number;
};
export const StyledArrowTopLeft = styled.div<StyledArrowTopProps>`
  position: absolute;
  top: 100%;
  left: calc(50% - ${({ arrowRadius }) => arrowRadius}px + 0.5px);

  width: ${({ arrowRadius }) => arrowRadius}px;
  height: ${({ verticalGapDesktop }) => verticalGapDesktop / 2 + 1}px;
  background-color: white;
  z-index: 1;

  div.actual-arrow {
    width: 100%;
    height: 100%;

    border: 1px dashed ${({ theme }) => theme.palette.stroke[1]};
    border-top: 0;
    border-left: 0;
    border-bottom-right-radius: ${({ arrowRadius }) => arrowRadius}px;
  }

  @media (max-width: 960px) {
    height: ${({ verticalGapMobile }) => verticalGapMobile / 2 + 1}px;
  }
`;

export const StyledArrowTopRight = styled.div<StyledArrowTopProps>`
  position: absolute;
  top: 100%;
  left: calc(50% - 0.5px);
  width: ${({ arrowRadius }) => arrowRadius}px;
  height: ${({ verticalGapDesktop }) => verticalGapDesktop / 2 + 1}px;

  background-color: white;
  z-index: 2;

  div.actual-arrow {
    width: 100%;
    height: 100%;

    border: 1px dashed ${({ theme }) => theme.palette.stroke[1]};
    border-top: 0;
    border-right: 0;
    border-bottom-left-radius: ${({ arrowRadius }) => arrowRadius}px;
  }

  @media (max-width: 960px) {
    height: ${({ verticalGapMobile }) => verticalGapMobile / 2 + 1}px;
  }
`;
